<section class="uk-section uk-padding-remove" appResponsiveCheck #resize="appResponsiveCheck">
    <div class="uk-position-relative uk-visible-toggle" tabindex="-1"
        uk-slideshow="min-height: 496; max-height: 527; autoplay: true; autoplay-interval: 3000">
        <ul class="uk-slideshow-items uk-padding-medium uk-padding-remove-horizontal">
            <li *ngFor="let product of products;let i=index;">
                <ng-container *ngIf="resize.responsiveCheck">
                    <!-- for desktop -->
                    <img [lazyload]="product.image2" alt="{{ product.alt_image ? product.alt_image : '' }}"
                        [autoload]="i<1?'true':'false'" uk-cover>
                </ng-container>
                <ng-container *ngIf="!resize.responsiveCheck">
                    <!-- for Mobile -->
                    <img [lazyload]="product.image1" alt="{{ product.alt_image ? product.alt_image : '' }}"
                        [autoload]="i<1?'true':'false'" uk-cover>
                </ng-container>
                <!-- <img [lazyload]="product.image1" [autoload]="i<1?'true':'false'" uk-cover sizes="100vw"> -->

                <div class="uk-height-1-1 uk-cover-container">
                    <div class="uk-overlay-primary uk-position-cover"></div>
                    <div class="uk-container uk-position-relative uk-height-1-1 uk-flex uk-flex-left uk-flex-middle">
                        <div class="uk-padding uk-position-relative uk-width-4-5@s uk-width-3-4@m">
                            <div class="uk-light uk-margin-medium-bottom">
                                <h2 class="header-divider +text-shadow">{{product.securityNameTH}}</h2>
                                <p class="uk-margin-remove-top +text-shadow">{{product.description1}}</p>
                            </div>
                            <div class="uk-text-center uk-text-left@s" uk-margin>
                                <a *ngIf="product.product_detail_button_flag && !product.url2 || slide"
                                    class="uk-button uk-button-default uk-border-rounded uk-light uk-margin-small-left uk-margin-small-right +text-white +background-transparent +border-white +btn-min-160"
                                    [routerLink]="[ (product.pathname ? product.pathname : '/products/product-detail') ]"
                                    [queryParams]="(product.pathname ? {} : { 
                                        'securityGroupID':product.securityGroupID, 
                                        'securityTypeID':product.securityTypeID ,
                                        'securitySubTypeID':product.securitySubTypeID,
                                        'securityID':product.securityID
                                    })">ดูรายละเอียด
                                </a>
                                <a *ngIf="product.product_detail_button_flag && product.url2"
                                    class="uk-button uk-button-default uk-border-rounded uk-light uk-margin-small-left uk-margin-small-right +text-white +background-transparent +border-white +btn-min-160"
                                    (click)="goUrl(product.url2)"
                                    href="javascript:void(0)">
                                    ดูรายละเอียด
                                </a>
                                <a *ngIf="product.online_sale_or_insure_interested_button_flag || slide"
                                    class="uk-button uk-border-rounded +btn-min-160 uk-margin-small-left uk-margin-small-right"
                                    (click)="openUrl(product)" [ngClass]="{
                                        'uk-button-primary': product.onlineSale,
                                        'uk-button-secondary': !product.onlineSale
                                    }">
                                    {{ product.onlineSale ? 'ซื้อประกันออนไลน์' : 'สนใจแบบประกัน'}}
                                </a>
                                <a *ngIf="product.other_button_flag && product.url3"
                                class="uk-button uk-button-default uk-border-rounded uk-light uk-margin-small-left uk-margin-small-right +text-white +background-transparent +border-white +btn-min-160"
                                (click)="goUrl(product.url3)"
                                href="javascript:void(0)">
                                    {{ product.temp_button_name }}
                                </a>
                                <a *ngIf="product.other_button_flag && !product.url3"
                                class="uk-button uk-button-default uk-border-rounded uk-light uk-margin-small-left uk-margin-small-right +text-white +background-transparent +border-white +btn-min-160"
                                    href="javascript:void(0)">
                                    {{ product.temp_button_name }}
                                </a>
                            </div>
                        </div>
                        <!-- please check best seller -->
                        <div *ngIf="slideData.slideType==='recommend'"
                            class="uk-position-medium uk-position-top-right uk-margin-remove uk-absolute uk-overflow-hidden insure-bestseller">
                            <img data-src="./assets/images/icon-best-seller@2x.png"
                                data-srcset="./assets/images/icon-best-seller@3x.png 650w, ./assets/images/icon-best-seller@3x.png 1300w"
                                sizes="(min-width: 650px) 650px, 100vw" width="69" height="81" alt="best seller" uk-img>
                        </div>
                    </div>
                </div>
            </li>
            <ng-container *ngIf="products.length===0">
                <li *ngFor="let i of [].constructor(1)">
                    <div class="uk-width-1-1 uk-height-1-1 skeleton-box"></div>
                </li>
            </ng-container>
        </ul>
        <div class="uk-light uk-visible@m">
            <a class="uk-position-large uk-position-center-left uk-slidenav-large uk-hidden-hover" href="#"
                uk-slidenav-previous uk-slideshow-item="previous"></a>
            <a class="uk-position-large uk-position-center-right uk-slidenav-large uk-hidden-hover" href="#"
                uk-slidenav-next uk-slideshow-item="next"></a>
        </div>
        <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-position-large uk-position-bottom-center"></ul>
    </div>
</section>